import {useEffect, useState} from 'react';

export type UseDialogStateReturn = {
  open: boolean;
  setOpen: (open: boolean, data?: any) => void;
  extraData?: any;
  openDialog: (data?: any) => void;
  closeDialog: () => void;
  toggleDialog: () => void;
};

const useDialogState: (defaultOpen?: boolean) => UseDialogStateReturn = (defaultOpen = false) => {
  const [open, setOpenInternal] = useState(defaultOpen || false);
  const [data, setData] = useState();

  function closeDialog() {
    setOpenInternal(false);
    setData(undefined);
  }
  function openDialog(data?: any) {
    setOpenInternal(true);
    setData(data);
  }

  function toggleDialog() {
    setOpenInternal(!open);
  }

  function setOpen(open: boolean, data?: any) {
    setOpenInternal(open);
    setData(data);
  }

  useEffect(() => {
    // https://github.com/radix-ui/primitives/issues/2122
    if (!open) setTimeout(() => (document.body.style.pointerEvents = ''), 0);
  }, [open]);

  return {open, extraData: data, openDialog, closeDialog, toggleDialog, setOpen};
};

export default useDialogState;
